// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file plugnmeet_auth_analytics.proto (package plugnmeet, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "./buf/validate/validate_pb";
import type { StatusCode } from "./plugnmeet_common_api_pb";
import { file_plugnmeet_common_api } from "./plugnmeet_common_api_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file plugnmeet_auth_analytics.proto.
 */
export const file_plugnmeet_auth_analytics: GenFile = /*@__PURE__*/
  fileDesc("Ch5wbHVnbm1lZXRfYXV0aF9hbmFseXRpY3MucHJvdG8SCXBsdWdubWVldCJUChFGZXRjaEFuYWx5dGljc1JlcRIQCghyb29tX2lkcxgBIAMoCRIMCgRmcm9tGAIgASgNEg0KBWxpbWl0GAMgASgNEhAKCG9yZGVyX2J5GAQgASgJInIKDUFuYWx5dGljc0luZm8SDwoHcm9vbV9pZBgBIAEoCRIPCgdmaWxlX2lkGAIgASgJEhEKCWZpbGVfbmFtZRgDIAEoCRIRCglmaWxlX3NpemUYBCABKAESGQoNY3JlYXRpb25fdGltZRgFIAEoA0ICMAEilAEKFEZldGNoQW5hbHl0aWNzUmVzdWx0EhsKD3RvdGFsX2FuYWx5dGljcxgBIAEoA0ICMAESDAoEZnJvbRgCIAEoDRINCgVsaW1pdBgDIAEoDRIQCghvcmRlcl9ieRgEIAEoCRIwCg5hbmFseXRpY3NfbGlzdBgFIAMoCzIYLnBsdWdubWVldC5BbmFseXRpY3NJbmZvIo0BChFGZXRjaEFuYWx5dGljc1JlcxIOCgZzdGF0dXMYASABKAgSCwoDbXNnGAIgASgJEioKC3N0YXR1c19jb2RlGAMgASgOMhUucGx1Z25tZWV0LlN0YXR1c0NvZGUSLwoGcmVzdWx0GAQgASgLMh8ucGx1Z25tZWV0LkZldGNoQW5hbHl0aWNzUmVzdWx0Ii0KEkRlbGV0ZUFuYWx5dGljc1JlcRIXCgdmaWxlX2lkGAEgASgJQga6SAPIAQEiXQoSRGVsZXRlQW5hbHl0aWNzUmVzEg4KBnN0YXR1cxgBIAEoCBILCgNtc2cYAiABKAkSKgoLc3RhdHVzX2NvZGUYAyABKA4yFS5wbHVnbm1lZXQuU3RhdHVzQ29kZSI3ChxHZXRBbmFseXRpY3NEb3dubG9hZFRva2VuUmVxEhcKB2ZpbGVfaWQYASABKAlCBrpIA8gBASKFAQocR2V0QW5hbHl0aWNzRG93bmxvYWRUb2tlblJlcxIOCgZzdGF0dXMYASABKAgSCwoDbXNnGAIgASgJEioKC3N0YXR1c19jb2RlGAMgASgOMhUucGx1Z25tZWV0LlN0YXR1c0NvZGUSEgoFdG9rZW4YBCABKAlIAIgBAUIICgZfdG9rZW5CpAEKDWNvbS5wbHVnbm1lZXRCG1BsdWdubWVldEF1dGhBbmFseXRpY3NQcm90b1ABWjJnaXRodWIuY29tL215bmFwYXJyb3QvcGx1Z25tZWV0LXByb3RvY29sL3BsdWdubWVldKICA1BYWKoCCVBsdWdubWVldMoCCVBsdWdubWVldOICFVBsdWdubWVldFxHUEJNZXRhZGF0YeoCCVBsdWdubWVldGIGcHJvdG8z", [file_buf_validate_validate, file_plugnmeet_common_api]);

/**
 * @generated from message plugnmeet.FetchAnalyticsReq
 */
export type FetchAnalyticsReq = Message<"plugnmeet.FetchAnalyticsReq"> & {
  /**
   * @generated from field: repeated string room_ids = 1;
   */
  roomIds: string[];

  /**
   * @generated from field: uint32 from = 2;
   */
  from: number;

  /**
   * @generated from field: uint32 limit = 3;
   */
  limit: number;

  /**
   * @generated from field: string order_by = 4;
   */
  orderBy: string;
};

/**
 * Describes the message plugnmeet.FetchAnalyticsReq.
 * Use `create(FetchAnalyticsReqSchema)` to create a new message.
 */
export const FetchAnalyticsReqSchema: GenMessage<FetchAnalyticsReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_analytics, 0);

/**
 * @generated from message plugnmeet.AnalyticsInfo
 */
export type AnalyticsInfo = Message<"plugnmeet.AnalyticsInfo"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * @generated from field: string file_id = 2;
   */
  fileId: string;

  /**
   * @generated from field: string file_name = 3;
   */
  fileName: string;

  /**
   * @generated from field: double file_size = 4;
   */
  fileSize: number;

  /**
   * @generated from field: int64 creation_time = 5 [jstype = JS_STRING];
   */
  creationTime: string;
};

/**
 * Describes the message plugnmeet.AnalyticsInfo.
 * Use `create(AnalyticsInfoSchema)` to create a new message.
 */
export const AnalyticsInfoSchema: GenMessage<AnalyticsInfo> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_analytics, 1);

/**
 * @generated from message plugnmeet.FetchAnalyticsResult
 */
export type FetchAnalyticsResult = Message<"plugnmeet.FetchAnalyticsResult"> & {
  /**
   * @generated from field: int64 total_analytics = 1 [jstype = JS_STRING];
   */
  totalAnalytics: string;

  /**
   * @generated from field: uint32 from = 2;
   */
  from: number;

  /**
   * @generated from field: uint32 limit = 3;
   */
  limit: number;

  /**
   * @generated from field: string order_by = 4;
   */
  orderBy: string;

  /**
   * @generated from field: repeated plugnmeet.AnalyticsInfo analytics_list = 5;
   */
  analyticsList: AnalyticsInfo[];
};

/**
 * Describes the message plugnmeet.FetchAnalyticsResult.
 * Use `create(FetchAnalyticsResultSchema)` to create a new message.
 */
export const FetchAnalyticsResultSchema: GenMessage<FetchAnalyticsResult> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_analytics, 2);

/**
 * @generated from message plugnmeet.FetchAnalyticsRes
 */
export type FetchAnalyticsRes = Message<"plugnmeet.FetchAnalyticsRes"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;

  /**
   * @generated from field: plugnmeet.StatusCode status_code = 3;
   */
  statusCode: StatusCode;

  /**
   * @generated from field: plugnmeet.FetchAnalyticsResult result = 4;
   */
  result?: FetchAnalyticsResult | undefined;
};

/**
 * Describes the message plugnmeet.FetchAnalyticsRes.
 * Use `create(FetchAnalyticsResSchema)` to create a new message.
 */
export const FetchAnalyticsResSchema: GenMessage<FetchAnalyticsRes> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_analytics, 3);

/**
 * @generated from message plugnmeet.DeleteAnalyticsReq
 */
export type DeleteAnalyticsReq = Message<"plugnmeet.DeleteAnalyticsReq"> & {
  /**
   * @generated from field: string file_id = 1;
   */
  fileId: string;
};

/**
 * Describes the message plugnmeet.DeleteAnalyticsReq.
 * Use `create(DeleteAnalyticsReqSchema)` to create a new message.
 */
export const DeleteAnalyticsReqSchema: GenMessage<DeleteAnalyticsReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_analytics, 4);

/**
 * @generated from message plugnmeet.DeleteAnalyticsRes
 */
export type DeleteAnalyticsRes = Message<"plugnmeet.DeleteAnalyticsRes"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;

  /**
   * @generated from field: plugnmeet.StatusCode status_code = 3;
   */
  statusCode: StatusCode;
};

/**
 * Describes the message plugnmeet.DeleteAnalyticsRes.
 * Use `create(DeleteAnalyticsResSchema)` to create a new message.
 */
export const DeleteAnalyticsResSchema: GenMessage<DeleteAnalyticsRes> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_analytics, 5);

/**
 * @generated from message plugnmeet.GetAnalyticsDownloadTokenReq
 */
export type GetAnalyticsDownloadTokenReq = Message<"plugnmeet.GetAnalyticsDownloadTokenReq"> & {
  /**
   * @generated from field: string file_id = 1;
   */
  fileId: string;
};

/**
 * Describes the message plugnmeet.GetAnalyticsDownloadTokenReq.
 * Use `create(GetAnalyticsDownloadTokenReqSchema)` to create a new message.
 */
export const GetAnalyticsDownloadTokenReqSchema: GenMessage<GetAnalyticsDownloadTokenReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_analytics, 6);

/**
 * @generated from message plugnmeet.GetAnalyticsDownloadTokenRes
 */
export type GetAnalyticsDownloadTokenRes = Message<"plugnmeet.GetAnalyticsDownloadTokenRes"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;

  /**
   * @generated from field: plugnmeet.StatusCode status_code = 3;
   */
  statusCode: StatusCode;

  /**
   * @generated from field: optional string token = 4;
   */
  token?: string | undefined;
};

/**
 * Describes the message plugnmeet.GetAnalyticsDownloadTokenRes.
 * Use `create(GetAnalyticsDownloadTokenResSchema)` to create a new message.
 */
export const GetAnalyticsDownloadTokenResSchema: GenMessage<GetAnalyticsDownloadTokenRes> = /*@__PURE__*/
  messageDesc(file_plugnmeet_auth_analytics, 7);

